import { Modal } from "antd";
import React from "react";
import PublicFormRenderer from "../../../components/generic/formbuilder/renderer/PublicFormRenderer";

const ModalPublicFormRendererComponent = ({
  isModalOpen,
  footer,
  formSubmitCallback,
  setIsModalOpen,
  formTitle,
  formTemplateData,
}) => {
  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div>
      <Modal
        destroyOnClose={true}
        bodyStyle={{ overflowY: "auto", marginTop: "60px", maxHeight: "75vh" }}
        centered
        okText={"Submit Form"}
        open={isModalOpen}
        onCancel={handleCloseModal}
        cancelButtonProps={{
          className: "custom-cancel-button",
        }}
        footer={footer}
        closable={true}
        title={formTitle}
      >
        <PublicFormRenderer
          formTemplateData={formTemplateData}
          formSubmitCallback={formSubmitCallback}
          formTitle={formTitle}
        />
      </Modal>
    </div>
  );
};

export default ModalPublicFormRendererComponent;
